module.exports = __webpack_public_path__ + "assets/6cacccef2155341fac71b97d875da916.png";